import { useState, useEffect, useRef } from 'react';
import './FilterBar.css';

const FilterBar = ({ resultCount, sortBy, onSortChange, onFilterChange, filters = {} }) => {
  const [showPriceFilter, setShowPriceFilter] = useState(false);
  const [showPassengersFilter, setShowPassengersFilter] = useState(false);
  const [showCategoryFilter, setShowCategoryFilter] = useState(false);
  
  const priceFilterRef = useRef(null);
  const passengersFilterRef = useRef(null);
  const categoryFilterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (priceFilterRef.current && !priceFilterRef.current.contains(event.target)) {
        setShowPriceFilter(false);
      }
      if (passengersFilterRef.current && !passengersFilterRef.current.contains(event.target)) {
        setShowPassengersFilter(false);
      }
      if (categoryFilterRef.current && !categoryFilterRef.current.contains(event.target)) {
        setShowCategoryFilter(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const priceRanges = [
    { label: 'Menos de $50.000', value: '0-50000' },
    { label: '$50.000 - $100.000', value: '50000-100000' },
    { label: '$100.000 - $200.000', value: '100000-200000' },
    { label: 'Más de $200.000', value: '200000-999999' }
  ];

  const passengerOptions = [2, 4, 5, 7];

  const categories = [
    'Sedán Económico MT',
    'Sedán Económico AT',
    'SUV Intermedio AT',
    'Compacto AT'
  ];

  const handleFilterChange = (filterType, value) => {
    if (onFilterChange) {
      onFilterChange(filterType, value);
    }
  };

  const activeFiltersCount = Object.values(filters).filter(v => v !== null && v !== undefined).length;

  return (
    <div className="filter-bar">
      <div className="filter-buttons">
        <div className="filter-dropdown" ref={priceFilterRef}>
          <button 
            className={`filter-btn ${filters.priceRange ? 'active' : ''}`}
            onClick={() => setShowPriceFilter(!showPriceFilter)}
          >
            <span className="icon">💰</span> Precio
            {filters.priceRange && <span className="filter-badge">1</span>}
          </button>
          {showPriceFilter && (
            <div className="filter-dropdown-menu">
              {priceRanges.map(range => (
                <label key={range.value} className="filter-option">
                  <input
                    type="radio"
                    name="priceRange"
                    value={range.value}
                    checked={filters.priceRange === range.value}
                    onChange={(e) => handleFilterChange('priceRange', e.target.value)}
                  />
                  <span>{range.label}</span>
                </label>
              ))}
              <button 
                className="clear-filter-btn"
                onClick={() => handleFilterChange('priceRange', null)}
              >
                Limpiar
              </button>
            </div>
          )}
        </div>

        <div className="filter-dropdown" ref={passengersFilterRef}>
          <button 
            className={`filter-btn ${filters.passengers ? 'active' : ''}`}
            onClick={() => setShowPassengersFilter(!showPassengersFilter)}
          >
            <span className="icon">👥</span> Pasajeros
            {filters.passengers && <span className="filter-badge">1</span>}
          </button>
          {showPassengersFilter && (
            <div className="filter-dropdown-menu">
              {passengerOptions.map(count => (
                <label key={count} className="filter-option">
                  <input
                    type="radio"
                    name="passengers"
                    value={count}
                    checked={filters.passengers === count}
                    onChange={(e) => handleFilterChange('passengers', parseInt(e.target.value))}
                  />
                  <span>{count} pasajeros</span>
                </label>
              ))}
              <button 
                className="clear-filter-btn"
                onClick={() => handleFilterChange('passengers', null)}
              >
                Limpiar
              </button>
            </div>
          )}
        </div>

        <div className="filter-dropdown" ref={categoryFilterRef}>
          <button 
            className={`filter-btn ${filters.category ? 'active' : ''}`}
            onClick={() => setShowCategoryFilter(!showCategoryFilter)}
          >
            <span className="icon">🚗</span> Categorías
            {filters.category && <span className="filter-badge">1</span>}
          </button>
          {showCategoryFilter && (
            <div className="filter-dropdown-menu">
              {categories.map(cat => (
                <label key={cat} className="filter-option">
                  <input
                    type="radio"
                    name="category"
                    value={cat}
                    checked={filters.category === cat}
                    onChange={(e) => handleFilterChange('category', e.target.value)}
                  />
                  <span>{cat}</span>
                </label>
              ))}
              <button 
                className="clear-filter-btn"
                onClick={() => handleFilterChange('category', null)}
              >
                Limpiar
              </button>
            </div>
          )}
        </div>

        {activeFiltersCount > 0 && (
          <button 
            className="clear-all-btn"
            onClick={() => {
              handleFilterChange('priceRange', null);
              handleFilterChange('passengers', null);
              handleFilterChange('category', null);
            }}
          >
            Limpiar todos ({activeFiltersCount})
          </button>
        )}
      </div>

      <div className="filter-results">
        <span className="result-count">{resultCount} resultados encontrados</span>
        <div className="sort-section">
          <span className="sort-icon">⬍</span>
          <span>Ordenar por:</span>
          <select value={sortBy} onChange={(e) => onSortChange(e.target.value)}>
            <option value="recommended">Recomendados</option>
            <option value="price-low">Precio: Menor a Mayor</option>
            <option value="price-high">Precio: Mayor a Menor</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
